export default __webpack_public_path__ + "static/media/manifestationofmitra.08b6fef2.png";